import './sec7.css';
import Speculation from "./speculation-components/Speculation";

const Sec7 = () => {
    return (
        <div className="sec7-section">
            <span>Speculation and property flipping in Boston refer to the</span>
            <span>practice of buying properties with the intent to resell</span>
            <span>them quickly for a profit, often contributing to housing</span>
            <span>market volatility and displacement of long-term residents.</span>

            <span className="extraPad"></span>


            <div id="speculation">
                <Speculation />
            </div>
        </div>

        
        
    );
};

export default Sec7;
